export default {
    "color": "Color",
    "secondaryColor": "Secondary color",
    "outerMaterial": "Outer Material",
    "modelName": "Model Name",
    "idealFor": "Ideal For",
    "occasion": "Occasion",
    "typeFormal": "Type Formal",
    "season": "Season",
    "soleMaterial": "Sole Material",
    "weight": "Weight",
    "packOf": "Pack Of",
    "careInstructions": "Care Instructions",
    "netQuantity": "Net Quantity",
    "tipShape": "Tip shape",
    "countryOfOrigin": "Country of Origin",
    "size": "Size",
    "itemShape": "Item Shape",
    "itemThickness": "Item Thickness",
    "productType": "Product Type",
    "brandName": "Brand Name",
    "modelNumber": "Model Number",
    "material": "Material",
    "numberOfItems": "Number of Items",
    "careInstructions": "Care Instructions",
    "threadCount": "Thread Count",
    "material": "Material",
    "pattern": "Pattern",
    "howItWorks": "How It Works",
    "compatible": "Compatible",
    "packageContains": "Package Contains",
    "availability": "Availability",
    "condition": "Condition"
}